import { render, staticRenderFns } from "./CustomFieldValueForm.vue?vue&type=template&id=70196874&"
import script from "./CustomFieldValueForm.vue?vue&type=script&lang=js&"
export * from "./CustomFieldValueForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports